var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3125 0.4375V13.3047C1.3125 13.5463 1.50838 13.7422 1.75 13.7422C1.99162 13.7422 2.1875 13.5463 2.1875 13.3047V7.29904C3.02939 7.79684 4.96323 8.68162 6.89706 7.74374C8.87672 6.78363 10.8564 7.30063 11.6646 7.59036C11.8434 7.65446 12.0441 7.52286 12.0441 7.33291V1.31612C12.0441 1.22426 11.9962 1.14016 11.9139 1.09933C11.3603 0.824593 9.12869 -0.123606 6.89706 1.1677C4.97519 2.27977 3.05332 1.32283 2.20325 0.766905C2.19806 0.763514 2.19281 0.760323 2.1875 0.757327V0.4375C2.1875 0.195875 1.99162 0 1.75 0C1.50838 0 1.3125 0.195875 1.3125 0.4375Z",
    fill: "#0B4D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/Icon_Flag.f5cd1527a8a19dba3d6285d6939d3451.svg";
export { ForwardRef as ReactComponent };